import { fetchApi } from "@tiny/utils";
import { GetFormsResponse } from "@/types/api/forms";
import { LoaderFunctionArgs } from "react-router-dom";

export async function formsLoader({ request }: LoaderFunctionArgs) {
  return fetchApi<GetFormsResponse>("/formservice/form", {
    signal: request.signal,
  });
}
